import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActiveHotels,
  getAllActiveWebHotels,
  getHotelByURL,
  insertWebsiteInquiry,
} from "@/services/hotel.services";

interface HotelState {
  loading: boolean;
  error: string;
  HotelList: unknown[];
  HotelDetails: Record<string, unknown>;
}

const initialState: HotelState = {
  loading: false,
  error: "",
  HotelList: [],
  HotelDetails: {},
};

const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    clearHotelDetails: (state) => {
      state.HotelDetails = initialState.HotelDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveWebHotels.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveWebHotels.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveWebHotels.rejected, (state, action) => {
      state.loading = false;
      state.HotelList = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveHotels.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveHotels.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveHotels.rejected, (state, action) => {
      state.loading = false;
      state.HotelList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHotelByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHotelByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getHotelByURL.rejected, (state, action) => {
      state.loading = false;
      state.HotelDetails = initialState.HotelDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertWebsiteInquiry.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(insertWebsiteInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertWebsiteInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default hotelSlice.reducer;
export const { clearHotelDetails } = hotelSlice.actions;
